import Loading from 'common/components/loading'
import LivePreview from 'modules/transmission/components/livePreview'
import LegalAlert from 'common/components/legalAlert'
import LiveContainer from 'modules/transmission/containers/live'
import { useTransmissionContext } from 'modules/transmission/context'
import { useLeadContext } from 'modules/lead/context'
import useSetupTransmission from 'modules/transmission/hooks/useSetupTransmission'
import useSetupLead from 'modules/lead/hooks/useSetupLead'
import { useAuth } from 'modules/auth/hooks/useAuth'

const LivePage = () => {
  const {
    transmissionData,
    isPrivate,
    loading
  } = useTransmissionContext()

  useSetupTransmission()

  const { postLead, leadData } = useLeadContext()
  const { isLogged } = useAuth()
  const { leadVariant } = useSetupLead()

  const isRegistered = Boolean(leadData.data.schedule === transmissionData.code)
  const isLoading = loading || leadData.isLoading

  const renderCaptureLead = () => {
    if (!leadData.showConfirm && !postLead.hasError && isRegistered && !leadVariant) {
      return <LiveContainer />
    }

    return (
      <LivePreview
        registered={isRegistered} />
    )
  }

  return (
    <div>
      {
        !transmissionData.code || isLoading
          ? (
            <div className="loading-container" data-test="loader">
              <Loading />
            </div>
          )
          : renderCaptureLead()
      }
      { !isRegistered
      && <LegalAlert isAccepted={isLogged() || isPrivate} />}
    </div>
  )
}

export default LivePage
